import { useState } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const Contacto = () => {
  const [formData, setFormData] = useState({
    nombre: '',
    email: '',
    telefono: '',
    empresa: '',
    asunto: '',
    mensaje: ''
  });
  const [charCount, setCharCount] = useState(0);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    if (name === 'mensaje') {
      if (value.length <= 500) {
        setFormData(prev => ({ ...prev, [name]: value }));
        setCharCount(value.length);
      }
    } else {
      setFormData(prev => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams();
      Object.entries(formData).forEach(([key, value]) => {
        formBody.append(key, value);
      });

      const response = await fetch('https://readdy.ai/api/form/d6pnvbkddmmni7ck85pg', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString()
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          nombre: '',
          email: '',
          telefono: '',
          empresa: '',
          asunto: '',
          mensaje: ''
        });
        setCharCount(0);
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-blue-900 via-blue-800 to-blue-700 text-white py-12 sm:py-16 md:py-20 lg:py-24 overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-20 left-10 w-72 h-72 bg-white rounded-full blur-3xl"></div>
          <div className="absolute bottom-20 right-10 w-96 h-96 bg-white rounded-full blur-3xl"></div>
        </div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 relative z-10">
          <div className="animate-on-scroll transition-all duration-700 text-center opacity-100 translate-y-0">
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-4 sm:mb-6">Contáctanos</h1>
            <p className="text-base sm:text-lg md:text-xl lg:text-2xl text-white/90 max-w-3xl mx-auto px-4">
              Estamos listos para atender tus necesidades de suministros de oficina en Puebla
            </p>
          </div>
        </div>
      </section>
      
      {/* Métodos de Contacto */}
      <section className="py-12 sm:py-16 lg:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 mb-12 sm:mb-16">
            <a
              href="https://wa.me/+522228121142"
              target="_blank"
              rel="noopener noreferrer"
              className="animate-on-scroll transition-all duration-700 bg-white p-6 sm:p-8 rounded-lg shadow-lg hover:shadow-2xl hover:-translate-y-2 duration-300 text-center border border-gray-100 cursor-pointer opacity-100 translate-y-0"
            >
              <div className="w-14 h-14 sm:w-16 sm:h-16 bg-gradient-to-br from-[#25D366] to-[#20BA5A] rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-whatsapp-line text-2xl sm:text-3xl text-white"></i>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-[#1e3a5f] mb-2">WhatsApp</h3>
              <p className="text-sm sm:text-base text-gray-600 break-words">2228121142</p>
            </a>
            
            <a
              href="tel:+522228121142"
              className="animate-on-scroll transition-all duration-700 bg-white p-6 sm:p-8 rounded-lg shadow-lg hover:shadow-2xl hover:-translate-y-2 duration-300 text-center border border-gray-100 cursor-pointer opacity-100 translate-y-0"
            >
              <div className="w-14 h-14 sm:w-16 sm:h-16 bg-gradient-to-br from-[#2d5a8c] to-[#1e3a5f] rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-phone-line text-2xl sm:text-3xl text-white"></i>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-[#1e3a5f] mb-2">Teléfono</h3>
              <p className="text-sm sm:text-base text-gray-600 break-words">2228121142</p>
            </a>
            
            <a
              href="mailto:cxventas.com.pue@gmail.com"
              className="animate-on-scroll transition-all duration-700 bg-white p-6 sm:p-8 rounded-lg shadow-lg hover:shadow-2xl hover:-translate-y-2 duration-300 text-center border border-gray-100 cursor-pointer opacity-100 translate-y-0"
            >
              <div className="w-14 h-14 sm:w-16 sm:h-16 bg-gradient-to-br from-[#2d5a8c] to-[#1e3a5f] rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-mail-line text-2xl sm:text-3xl text-white"></i>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-[#1e3a5f] mb-2">Email</h3>
              <p className="text-sm sm:text-base text-gray-600 break-words">cxventas.com.pue@gmail.com</p>
            </a>
          </div>
          
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12">
            {/* Formulario */}
            <div className="animate-on-scroll transition-all duration-700 opacity-100 translate-y-0">
              <h2 className="text-2xl sm:text-3xl font-bold text-[#1e3a5f] mb-4 sm:mb-6">Envíanos un Mensaje</h2>
              
              {submitStatus === 'success' && (
                <div className="mb-6 p-4 bg-green-50 border border-green-200 rounded-lg text-green-700">
                  <i className="ri-checkbox-circle-line text-xl mr-2"></i>
                  ¡Mensaje enviado con éxito! Te contactaremos pronto.
                </div>
              )}
              
              {submitStatus === 'error' && (
                <div className="mb-6 p-4 bg-red-50 border border-red-200 rounded-lg text-red-700">
                  <i className="ri-error-warning-line text-xl mr-2"></i>
                  Hubo un error al enviar el mensaje. Por favor, intenta nuevamente.
                </div>
              )}
              
              <form id="contact-form" data-readdy-form onSubmit={handleSubmit} className="space-y-4 sm:space-y-5">
                <div>
                  <label htmlFor="nombre" className="block text-sm font-semibold text-gray-700 mb-2">
                    Nombre Completo *
                  </label>
                  <input
                    id="nombre"
                    name="nombre"
                    required
                    value={formData.nombre}
                    onChange={handleChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#2d5a8c] text-sm"
                    placeholder="Juan Pérez"
                  />
                </div>
                
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-5">
                  <div>
                    <label htmlFor="email" className="block text-sm font-semibold text-gray-700 mb-2">
                      Email *
                    </label>
                    <input
                      id="email"
                      name="email"
                      type="email"
                      required
                      value={formData.email}
                      onChange={handleChange}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#2d5a8c] text-sm"
                      placeholder="juan@empresa.com"
                    />
                  </div>
                  <div>
                    <label htmlFor="telefono" className="block text-sm font-semibold text-gray-700 mb-2">
                      Teléfono *
                    </label>
                    <input
                      id="telefono"
                      name="telefono"
                      type="tel"
                      required
                      value={formData.telefono}
                      onChange={handleChange}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#2d5a8c] text-sm"
                      placeholder="222-123-4567"
                    />
                  </div>
                </div>
                
                <div>
                  <label htmlFor="empresa" className="block text-sm font-semibold text-gray-700 mb-2">
                    Empresa
                  </label>
                  <input
                    id="empresa"
                    name="empresa"
                    value={formData.empresa}
                    onChange={handleChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#2d5a8c] text-sm"
                    placeholder="Nombre de tu empresa"
                  />
                </div>
                
                <div>
                  <label htmlFor="asunto" className="block text-sm font-semibold text-gray-700 mb-2">
                    Asunto *
                  </label>
                  <select
                    id="asunto"
                    name="asunto"
                    required
                    value={formData.asunto}
                    onChange={handleChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#2d5a8c] text-sm cursor-pointer"
                  >
                    <option value="">Selecciona un asunto</option>
                    <option value="Cotización">Solicitar Cotización</option>
                    <option value="Información">Información de Productos</option>
                    <option value="Crédito">Línea de Crédito Empresarial</option>
                    <option value="Soporte">Soporte y Garantías</option>
                    <option value="Otro">Otro</option>
                  </select>
                </div>
                
                <div>
                  <label htmlFor="mensaje" className="block text-sm font-semibold text-gray-700 mb-2">
                    Mensaje *
                  </label>
                  <textarea
                    id="mensaje"
                    name="mensaje"
                    required
                    rows={5}
                    maxLength={500}
                    value={formData.mensaje}
                    onChange={handleChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#2d5a8c] resize-none text-sm"
                    placeholder="Cuéntanos cómo podemos ayudarte..."
                  ></textarea>
                  <p className="text-sm text-gray-500 mt-1">{charCount}/500 caracteres</p>
                </div>
                
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="w-full bg-[#2d5a8c] text-white px-6 sm:px-8 py-3 sm:py-4 rounded-lg text-sm sm:text-base font-semibold hover:bg-[#1e3a5f] transition-all duration-300 shadow-lg hover:shadow-xl disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2 whitespace-nowrap cursor-pointer"
                >
                  {isSubmitting ? (
                    <>
                      <i className="ri-loader-4-line text-lg sm:text-xl animate-spin"></i>
                      Enviando...
                    </>
                  ) : (
                    <>
                      <i className="ri-send-plane-line text-lg sm:text-xl"></i>
                      Enviar Mensaje
                    </>
                  )}
                </button>
              </form>
            </div>
            
            {/* Información de Contacto */}
            <div className="animate-on-scroll transition-all duration-700 delay-200 opacity-100 translate-y-0">
              <h2 className="text-2xl sm:text-3xl font-bold text-[#1e3a5f] mb-2">Nuestro Alcance Geográfico</h2>
              <p className="text-sm sm:text-base text-gray-600 mb-4 sm:mb-6">
                Atendemos empresas y negocios en toda la zona metropolitana de Puebla y alrededores.
              </p>
              
              <div className="mb-6 sm:mb-8 rounded-lg overflow-hidden shadow-lg h-[300px] sm:h-[400px]">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d120615.72236587308!2d-98.24353087343751!3d19.041431699999998!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85cfc0c6c2e689e9%3A0x6b9c2a0c5c8e8e8e!2sPuebla%2C%20Pue.!5e0!3m2!1ses!2smx!4v1234567890123!5m2!1ses!2smx"
                  width="100%"
                  height="100%"
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Zona de cobertura CX Comercializadora Puebla"
                ></iframe>
              </div>
              
              <div className="bg-gray-50 p-4 sm:p-6 rounded-lg border border-gray-200 mb-4 sm:mb-6">
                <h3 className="text-lg sm:text-xl font-bold text-[#1e3a5f] mb-3 sm:mb-4 flex items-center gap-2">
                  <i className="ri-map-pin-2-line text-xl sm:text-2xl"></i>
                  Zonas de Cobertura
                </h3>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 sm:gap-3">
                  <div className="flex items-center gap-2 text-gray-700 text-sm">
                    <i className="ri-checkbox-circle-fill text-green-500 text-base flex-shrink-0"></i>
                    <span>Puebla Centro</span>
                  </div>
                  <div className="flex items-center gap-2 text-gray-700 text-sm">
                    <i className="ri-checkbox-circle-fill text-green-500 text-base flex-shrink-0"></i>
                    <span>Zona Angelópolis</span>
                  </div>
                  <div className="flex items-center gap-2 text-gray-700 text-sm">
                    <i className="ri-checkbox-circle-fill text-green-500 text-base flex-shrink-0"></i>
                    <span>San Andrés Cholula</span>
                  </div>
                  <div className="flex items-center gap-2 text-gray-700 text-sm">
                    <i className="ri-checkbox-circle-fill text-green-500 text-base flex-shrink-0"></i>
                    <span>San Pedro Cholula</span>
                  </div>
                  <div className="flex items-center gap-2 text-gray-700 text-sm">
                    <i className="ri-checkbox-circle-fill text-green-500 text-base flex-shrink-0"></i>
                    <span>Zona Industrial</span>
                  </div>
                </div>
                <p className="mt-3 sm:mt-4 text-xs sm:text-sm text-gray-500 flex items-start gap-1">
                  <i className="ri-information-line flex-shrink-0 mt-0.5"></i>
                  <span>Operamos 100% en línea con entregas a domicilio en toda la región.</span>
                </p>
                <p className="mt-2 text-xs sm:text-sm text-gray-500 flex items-start gap-1">
                  <i className="ri-information-line flex-shrink-0 mt-0.5"></i>
                  <span>Costo de envío adicional para zonas fuera de la ciudad de Puebla.</span>
                </p>
              </div>
              
              <div className="bg-gray-50 p-4 sm:p-6 rounded-lg border border-gray-200 mb-4 sm:mb-6">
                <h3 className="text-lg sm:text-xl font-bold text-[#1e3a5f] mb-3 sm:mb-4 flex items-center gap-2">
                  <i className="ri-time-line text-xl sm:text-2xl"></i>
                  Horario de Atención
                </h3>
                <div className="space-y-2 text-sm sm:text-base text-gray-700">
                  <div className="flex justify-between">
                    <span className="font-semibold">Lunes a Viernes:</span>
                    <span>8:00 AM - 6:00 PM</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="font-semibold">Sábados:</span>
                    <span>9:00 AM - 2:00 PM</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="font-semibold">Domingos:</span>
                    <span className="text-red-600">Cerrado</span>
                  </div>
                </div>
              </div>
              
              <div className="bg-gradient-to-br from-[#2d5a8c] to-[#1e3a5f] p-4 sm:p-6 rounded-lg text-white">
                <h3 className="text-lg sm:text-xl font-bold mb-3 sm:mb-4">¿Necesitas Atención Inmediata?</h3>
                <p className="mb-3 sm:mb-4 text-sm sm:text-base text-white/90">
                  Contáctanos por WhatsApp y recibe respuesta en minutos
                </p>
                <a
                  href="https://wa.me/+522228121142?text=Hola,%20necesito%20información%20sobre%20CX%20Comercializadora"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center gap-2 bg-[#25D366] text-white px-5 sm:px-6 py-2.5 sm:py-3 rounded-lg text-sm sm:text-base font-semibold hover:bg-[#20BA5A] transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer w-full sm:w-auto"
                >
                  <i className="ri-whatsapp-line text-xl sm:text-2xl"></i>
                  Chatear Ahora
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      <Footer />
    </div>
  );
};

export default Contacto;